import { API_ENDPOINTS, API_PREFIX } from '@/config/const';
import { APP_ENV } from '@/config/env';
import { ResponseError } from '@/utils/Errors/ResponseError';

export async function registerAction(email: string, password: string) {
  const response = await fetch(`${APP_ENV.apiUrl}/${API_PREFIX}/${API_ENDPOINTS.register}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email, password }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new ResponseError(data?.message || 'Sorry, something went wrong.', response);
  }

  return data;
}
